import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Validation from '../setting/conform-pass.validator';
import { LoaderService } from '../loader/loader.service';
import { ApiService } from '../service/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  constructor(
     private readonly formBuilder: FormBuilder,
     private readonly loaderService: LoaderService,
     private readonly _http: ApiService,
     private readonly toaster: ToastrService,
     private readonly router: Router,
  ) { }
  userForm: any = FormGroup;
  isSubmitted = false;

  ngOnInit(): void {
    this.createForm();
  }


  createForm() {
    this.userForm = this.formBuilder.group({
      Id: [0],
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
          Validators.pattern(/^(?!\s*$).+/)
        ]),
      ],
      firstName: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(30), Validators.pattern(/^(?!\s*$).+/)]),
      ],
      lastName: [''],
      password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?!\s*$).+/)]], //new pass
      confirmPassword: ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?!\s*$).+/)]],
      isAdmin: [false],
      isActive: [true],
    }, {
      validators: Validation.match('password', 'confirmPassword')
    });
  }
  submitUser(): void {
    this.isSubmitted = true;
    if (this.userForm.invalid) {
      this.userForm.markAllAsTouched();
      return;
    }
    const formData = this.userForm.value;
    this.loaderService.show();
    this._http.saveUser(formData)
      .subscribe((response: any) => {
        if (response["Success"] === true && response["Data"] != null) {
          this.loaderService.hide();
          this.router.navigate(['/login']);
          this.toaster.success('Your account has been successfully created.');
        } else if (response["ResponseCode"] == 404) {
          this.toaster.error('Email is Already Exists.');
          this.loaderService.hide();
        }
        else {
          this.toaster.error('Something went wrong. Please try again later.');
          this.loaderService.hide();
        }
      })
  }
  redirectLogin(){
    this.router.navigate(['/login']);
  }
}
